var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGroup428 = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#30475e;stroke:#fff}.cls-2{fill:none}.cls-3{fill:#fff}.cls-4{stroke:none}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_427",
  "data-name": "Group 427",
  transform: "translate(-682 -508)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_9",
  className: "cls-1",
  "data-name": "Ellipse 9",
  transform: "translate(683 509)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  className: "cls-4"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10.5,
  className: "cls-2"
})), /*#__PURE__*/React.createElement("g", {
  id: "check-24px",
  transform: "translate(684.143 510.143)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_88",
  d: "M0 0h17.715v17.715H0z",
  className: "cls-2",
  "data-name": "Path 88"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_89",
  d: "M7.536 13.4l-3.078-3.079-1.048 1.041 4.126 4.126 8.857-8.857-1.04-1.041z",
  className: "cls-3",
  "data-name": "Path 89",
  transform: "translate(-.893 -1.464)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGroup428);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/Group_428.05d586dd3f70a64dc8992ea22413a14f.svg";